import { render, staticRenderFns } from "./StatisticsInventoryPanel.vue?vue&type=template&id=7c0817e6&scoped=true"
import script from "./StatisticsInventoryPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsInventoryPanel.vue?vue&type=script&lang=js"
import style0 from "./StatisticsInventoryPanel.vue?vue&type=style&index=0&id=7c0817e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0817e6",
  null
  
)

export default component.exports